GatorSurvey.app.service("surveyResultsService", ['$http', SurveyResultsService]);

function SurveyResultsService($http) {
    var self = this;

    this.GetResults = function(surveyId) {
        return $http.get("api/survey/results/" + surveyId).then(function(response) {
            return response.data;
        }, function(response) {
            throw (response.data);
        });
    };

    this.GetResponse = function(surveyId, respoinceId) {
        return $http.get("api/survey/results/" + surveyId + "/response/" +respoinceId).then(function(response) {
            return response.data;
        }, function(response) {
            throw (response.data); 
        });
    };


    this.GetSurveyResult = function (surveyId) {
        return $http.get("api/survey/results/" + surveyId + "/results").then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    this.GetAllQuestionResponces = function (surveyId) {
        return $http.get("api/survey/results/" + surveyId + "/questionAll").then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };


    this.GetQuestionResponces = function (surveyId, questionId, version) {
        if (typeof version == "undefined")
            version = -1;
        return $http.get("api/survey/results/" + surveyId + "/question/" + questionId + "?v=" + version).then(function (response) {
            return response.data;
        }, function(response) {
            throw (response.data);
        });
    };

    this.GetAccessedVsCompleted = function(surveyId) {
        return $http.get("api/Survey/Results/" + surveyId + "/AccessVsCompleted").then(function(response) {
            return response.data;
        }, function(response) {
            throw (response.data);
        });
    };

    this.GetAccessedVsCompletedAtVersion = function (surveyId,version) {
        return $http.get("api/Survey/Results/" + surveyId + "/AccessVsCompleted/"+version).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    this.GetRetakeCount = function (surveyId) {
        return $http.get("api/Survey/Results/" + surveyId + "/RetakeCount").then(function (response) {

            try {
                return response.data;
            } catch (e) {
                return 0;
            } 
        }, function (response) {
            throw (response.data);
        });
    };
    this.GetExport = function(surveyId, exportId) {
        return $http.get("api/Survey/Results/" + surveyId + "/Export/" + exportId).then(function(response) {
                return response.data;
            },
            function(response) {
                throw (response.data);
            });
    };

    this.RequestExport = function (surveyId,version) {
        return $http.get("api/Survey/Results/" + surveyId + "/Export/" + version).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    this.GetExportList = function() {
        return $http.get("api/survey/results/exports").then(function(response) {
                return response.data;
            },
            function(response) {
                throw (response.data);
            });
    };
}